export default __webpack_public_path__ + "static/media/BBB.54c77788.webp";